import { ComponentFactoryResolver, ComponentRef, EventEmitter, Injectable, Output, Type, ViewContainerRef } from '@angular/core';
import { Subject } from 'rxjs';
import { AddEditFragment, CLICK_OUTSIDE_MODAL } from 'src/app/fragments/modal/add-edit/add-edit.fragment';
import { AddPatientFragment } from 'src/app/fragments/modal/add-patient/add-patient.fragment';
import { AlertMessageFragment } from 'src/app/fragments/modal/alert-message/alert-message.fragment';
import { ConfirmationMessageFragment } from 'src/app/fragments/modal/confirmation-message/confirmation-message.fragment';
import { InsQualificationFragment } from 'src/app/fragments/modal/ins-qualification/ins-qualification.fragment';
import { LoadingModalFragment } from 'src/app/fragments/modal/loading/loading-modal.fragment';
import { MemoFragment } from 'src/app/fragments/modal/memo/memo.fragment';
import { Destinataire } from 'src/app/utils/interfaces/new/destinataire.interface';
import { MultipleChoiceFragment, MultipleChoiceOptions } from 'src/app/fragments/modal/multiple-choice/multiple-choice.fragment';
import { FormTemplate } from 'src/app/utils/interfaces/new/form-template.interfac';
import { LocalAuth } from 'src/app/utils/interfaces/new/localauth.interface';
import { AlarmeFragment } from 'src/app/fragments/modal/alarme/alarme.fragment';
import { FichePatient } from 'src/app/utils/interfaces/new/fiche-patient.interface';
import { AlarmsPatient } from 'src/app/utils/interfaces/new/alarms-patient.interface';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { HistoProfessionFragment } from 'src/app/fragments/modal/histo-profession/histo-profession.fragment';
import { Profession } from 'src/app/utils/interfaces/new/profession.interface';
import { Adresse } from 'src/app/utils/interfaces/new/adresse.interface';
import { HistoContactFragment } from 'src/app/fragments/modal/histo-contact/histo-contact.fragment';
import { ContactsPatient } from 'src/app/utils/interfaces/new/contacts-patient';
import { HistoRepertoireFragment } from 'src/app/fragments/modal/histo-repertoire/histo-repertoire.fragment';
import { CombinatedDroits } from 'src/app/utils/interfaces/new/combinateddroits.interface';
import { ParentPatientFragment } from 'src/app/fragments/modal/parent-patient/parent-patient.fragment';
import { CritereAttache } from 'src/app/utils/interfaces/new/CritereAttache';
import { AideSaisieFragment } from 'src/app/fragments/modal/aide-saisie/aide-saisie.fragment';
import { RechercheMultiListeFragment } from 'src/app/fragments/modal/recherche-multi-liste/recherche-multi-liste.fragment';
import { RechercheMultiCriteres } from 'src/app/utils/interfaces/new/recherche';
import { RechercheMultiSaveFragment } from 'src/app/fragments/modal/recherche-multi-save/recherche-multi-save.fragment';
import { Referentiel } from 'src/app/utils/interfaces/new/referentiel.interface';
import { ReferentielNewFragment } from 'src/app/fragments/modal/referentiel-new/referentiel-new.fragment';
import { SaisieGuideeFragment } from 'src/app/fragments/modal/saisie-guidee/saisie-guidee.fragment';
import { SearchCritereFragment } from 'src/app/fragments/modal/search-critere/search-critere.fragment';
import { ConsultDataFragment } from 'src/app/fragments/modal/consult-data/consult-data.fragment';
import { GroupementNewFragment } from 'src/app/fragments/modal/groupement-new/groupement-new.fragment';
import { GroupementCriteres } from 'src/app/utils/interfaces/new/GroupementCriteres';
import { Courrier } from 'src/app/utils/interfaces/new/Courrier';
import { AddCorrespondantCourrier } from 'src/app/fragments/modal/add-correspondant-courrier/add-correspondant-courrier.fragment';
import { EditCourrierFragment } from 'src/app/fragments/modal/edit-courrier/edit-courrier.fragment';
import { CreateCourrier } from 'src/app/utils/interfaces/new/create-courrier.interface';
import { Consultation } from 'src/app/utils/interfaces/new/consultation.interface';
import { SelectConsultationFragment } from 'src/app/fragments/modal/select-consultation/select-consultation.fragment';
import { AddCourrierPersoFragment } from 'src/app/fragments/modal/add-courrier-perso/add-courrier-perso.fragment';
import { SelectListFragment } from 'src/app/fragments/modal/select-list/select-list.fragment';
import { InfosPatientCarteVitale } from 'src/app/utils/interfaces/new/infos-patient-carte-vitale.interface';
import { ConsultationService } from '../consultation/consultation.service';
import { InsiFragment } from 'src/app/fragments/modal/insi/insi.fragment';
import { RechercheBddMedFragment } from 'src/app/fragments/modal/recherche-bdd-med/recherche-bdd-med.fragment';
import { SynapseCardiacFailureEnum, SynapseEntiteTherapeutique, SynapseHepaticFailureEnum, SynapseKidneyFailureEnum, SynapsePatientProfile } from '../synapse-medicine/autocomplete.service';
import { SearchPatientsFragment } from 'src/app/fragments/modal/search-patients/search-patients.fragment';
import { SearchCim10Fragment } from 'src/app/fragments/modal/search-cim10/search-cim10.fragment';
import { EditOrdonnanceFragment } from 'src/app/fragments/modal/edit-ordonnance/edit-ordonnance.fragment';
import { FicheSamFragment } from 'src/app/fragments/modal/fiche-sam/fiche-sam.fragment';
import { InfoCorrespondantFragment } from 'src/app/fragments/modal/info-correspondant/info-correspondant.fragment';
import { AnnuaireResultCorrespondant } from 'src/app/utils/interfaces/new/annuaire-result-correspondant.interface';
import { SearchMedNomFragment } from 'src/app/fragments/modal/search-med-nom/search-med-nom.fragment';
import { Filtres } from 'src/app/utils/interfaces/new/filtres.interface';
import { AddCorrespondantInEditorComponent } from 'src/app/fragments/modal/add-correspondant-in-editor/add-correspondant-in-editor.component';
import { Correspondant } from 'src/app/utils/interfaces/new/correspondant.interface';
import { ConfirmationChoixCustomComponent } from 'src/app/fragments/modal/confirmation-choix-custom/confirmation-choix-custom.component';
import { EditAdressePatientComponent } from 'src/app/fragments/modal/edit-adresse-patient/edit-adresse-patient.fragment';
import { SelectDocumentModalComponent } from 'src/app/fragments/modal/select-document-modal/select-document-modal.component';
import { CritereHistoriqueItem } from 'src/app/utils/interfaces/new/critere-historique-item.interface';

interface AddEditModalButtonsText {
  cancelButtonText?: string;
  updateButtonText?: string;
  validateButtonText?: string;
  customCssClass?: string;
}

interface AddPatientReferenceList {
  docsIdentiteList: Referentiel[];
  attributsIdentiteList: Referentiel[];
}

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  @Output() public closeEmitter = new EventEmitter();

  constructor(
    private resolver: ComponentFactoryResolver
  ) { }

  public openModal<T>(viewContainerRef: ViewContainerRef, component: Type<T>, options?: any): ComponentRef<T> {
    const factory = this.resolver.resolveComponentFactory(component);
    const result = viewContainerRef.createComponent(factory);
    if (options && options.length > 0) {
      for (const option of options) {
        result.instance[option.name] = option.value;
      }
    }
    return result;
  }

  public openLoading(viewContainerRef: ViewContainerRef, message?: string): ComponentRef<LoadingModalFragment> {
    const factory = this.resolver.resolveComponentFactory(LoadingModalFragment);
    const container = viewContainerRef.createComponent(factory);
    if (message) {
      container.instance.message = message;
    }
    return container;
  }

  public openAlert(viewContainerRef: ViewContainerRef, header: string, msg: string, buttonText?: string, errorDetails?: string): ComponentRef<AlertMessageFragment> {
    const factory = this.resolver.resolveComponentFactory(AlertMessageFragment);
    const container = viewContainerRef.createComponent(factory);
    container.instance.header = header;
    container.instance.msg = msg;
    container.instance.buttonText = buttonText;
    container.instance.errorDetails = errorDetails;
    const sub = container.instance.closeEmitter.subscribe(() => {
      this.close(container);
      sub.unsubscribe();
    });
    return container;
  }

  public openInfoCorrespondant(viewContainerRef: ViewContainerRef, correspondant: AnnuaireResultCorrespondant): ComponentRef<InfoCorrespondantFragment> {
    const factory = this.resolver.resolveComponentFactory(InfoCorrespondantFragment);
    const container = viewContainerRef.createComponent(factory);
    container.instance.correspondantInfos = correspondant;
    return container;
  }

  public openModalAddEdit(title: string, viewContainerRef: ViewContainerRef, formTemplate: FormTemplate, isEdit: boolean, object?: any, droits?: CombinatedDroits, buttons?:AddEditModalButtonsText, considerOutsideModalClick?: boolean): ComponentRef<AddEditFragment> {
    const factory = this.resolver.resolveComponentFactory(AddEditFragment);
    const container = viewContainerRef.createComponent(factory);
    container.instance.modalTitle = title;
    container.instance.isEdit = isEdit;
    container.instance.formTemplate = formTemplate;

    if (buttons && buttons.cancelButtonText) {
      container.instance.cancelButtonText = buttons.cancelButtonText;
    }
    if (buttons && buttons.updateButtonText) {
      container.instance.updateButtonText = buttons.updateButtonText;
    }
    if (buttons && buttons.validateButtonText) {
      container.instance.validateButtonText = buttons.validateButtonText;
    }
    if (buttons && buttons.customCssClass) {
      container.instance.customCssClass = buttons.customCssClass;
    }

    if (droits) {
      container.instance.droits = droits;
    }
    if (object) {
      container.instance.objectToEdit = object;
    }
    const sub = container.instance.closeEmitter.subscribe(async object => {
      if (considerOutsideModalClick && object === CLICK_OUTSIDE_MODAL) {
        if (!object) {
          this.closeEmitter.emit(null);
          this.close(container);
        } else if (object === CLICK_OUTSIDE_MODAL) {
          const loadingModal = this.openLoading(viewContainerRef);
          const resp = { object: CLICK_OUTSIDE_MODAL, isEdit: isEdit, loadingModal: loadingModal, addEditFragment: container };
          this.closeEmitter.emit(resp);
        } else {
          const loadingModal = this.openLoading(viewContainerRef);
          const resp = { object: object, isEdit: isEdit, loadingModal: loadingModal, addEditFragment: container };
          this.closeEmitter.emit(resp);
        }
      } else {
        if (!object || object === CLICK_OUTSIDE_MODAL) {
          this.closeEmitter.emit(null);
          this.close(container);
        } else {
          const loadingModal = this.openLoading(viewContainerRef);
          const resp = { object: object, isEdit: isEdit, loadingModal: loadingModal, addEditFragment: container };
          this.closeEmitter.emit(resp);
        }
      }

      sub.unsubscribe();
    });

    return container;
  }

  public openModalConfirmation(viewContainerRef: ViewContainerRef, header: string, msg: string, list?: string[], standalone?: boolean) {
    const factory = this.resolver.resolveComponentFactory(ConfirmationMessageFragment);
    const container = viewContainerRef.createComponent(factory);
    container.instance.header = header;
    container.instance.msg = msg;
    if (list) {
      container.instance.list = list;
    }
    if (!standalone) {
      const sub = container.instance.closeEmitter.subscribe((res: boolean) => {
        if (!res) {
          this.close(container);
          this.closeEmitter.emit(res);
        } else {
          this.closeEmitter.emit(res);
          this.close(container);
        }
        sub.unsubscribe();
      });
    }
    return container;
  }

  public openModalInsQualification(viewContainerRef: ViewContainerRef, header: string, msg: string, list: string[], documents: { value: string, label: string }[], defaultSelectedDoc?: string, hideQualification: boolean = false): ComponentRef<InsQualificationFragment> {
    const factory = this.resolver.resolveComponentFactory(InsQualificationFragment);
    const container = viewContainerRef.createComponent(factory);
    container.instance.header = header;
    container.instance.msg = msg;
    container.instance.list = list;
    container.instance.documents = documents;
    container.instance.hideQualification = hideQualification;
    if (defaultSelectedDoc) {
      container.instance.selectedDocument = defaultSelectedDoc;
    }
    // L'abonnement est géré par l'appelant (etat-civil.component.ts)
    return container;
  }


  public openModalFicheSam(viewContainerRef: ViewContainerRef, fichesSam: any[], patientId: string) {
    const factory = this.resolver.resolveComponentFactory(FicheSamFragment);
    const container = viewContainerRef.createComponent(factory);
    container.instance.fichesSam = fichesSam;
    container.instance.patientId = patientId;
    return container;
  }
  public openModalMemo(viewContainerRef: ViewContainerRef, header: string, author: LocalAuth, users: any, mode: string, refreshStream: Subject<any>, object?: any): ComponentRef<MemoFragment> {
    const factory = this.resolver.resolveComponentFactory(MemoFragment);
    const container = viewContainerRef.createComponent(factory);
    container.instance.header = header;
    container.instance.author = author;
    container.instance.mode = mode;
    container.instance.users = users;
    container.instance.selectedUsers = [];
    container.instance.refreshStream = refreshStream;
    if (object) {
      container.instance.editMemo = object;
    }
    const sub = container.instance.closeEmitter.subscribe((object: any) => {
      if (!object) {
        this.close(container);
      } else {
        const loadingModal = this.openLoading(viewContainerRef);
        this.closeEmitter.emit({ object: object, mode: mode, loadingModal: loadingModal, memoFragment: container });
        this.close(container);
      }
      sub.unsubscribe();
    });
    return container;
  }

  public openModalMultipleChoice(viewContainerRef: ViewContainerRef, header: string, msgExplication: string, msgQuestion: string, propositions: Array<{ label: string, value: string, backgroundColor?: string }>, autoClose = true, options?:MultipleChoiceOptions) {
    const factory = this.resolver.resolveComponentFactory(MultipleChoiceFragment);
    const container = viewContainerRef.createComponent(factory);
    container.instance.header = header;
    container.instance.msgExplication = msgExplication;
    container.instance.msgQuestion = msgQuestion;
    container.instance.arrayPropositions = propositions;
    if (options) {
      container.instance.options = options;
    }
    const sub = container.instance.closeEmitter.subscribe((res: string | null) => {
      this.closeEmitter.emit(res);
      if (autoClose) {
        this.close(container);
        sub.unsubscribe();
      }
    });
    return container;
  }

  public openModalAddPatient(title: string, viewContainerRef: ViewContainerRef, refList: AddPatientReferenceList, infosPatientCarteVitale?: InfosPatientCarteVitale): ComponentRef<AddPatientFragment> {
    const factory = this.resolver.resolveComponentFactory(AddPatientFragment);
    const container = viewContainerRef.createComponent(factory);
    container.instance.infosPatient = infosPatientCarteVitale;
    container.instance.modalTitle = title;
    container.instance.attributsIdentiteList = refList.attributsIdentiteList;
    container.instance.docsIdentiteList = refList.docsIdentiteList;
    const subClose = container.instance.closeEmitter.subscribe(resp => {
      if (resp) {
        subClose.unsubscribe();
      } else {
        const confirmModal = this.openModalConfirmation(viewContainerRef, "Annulation", "Confirmez-vous l'annulation de la saisie ? Les données ne seront pas enregistrées.", undefined, true);
        const sub = confirmModal.instance.closeEmitter.subscribe(res => {
          if (res) {
            this.close(confirmModal);
            this.close(container);
            this.closeEmitter.emit();
            subClose.unsubscribe();
            sub.unsubscribe();
          } else {
            this.close(confirmModal);
            sub.unsubscribe();
          }
        });
      }
    });
    return container;
  }

  public openModalAideSaisie(title: string, viewContainerRef: ViewContainerRef, objectToEdit: CritereAttache): ComponentRef<AideSaisieFragment> {
    const factory = this.resolver.resolveComponentFactory(AideSaisieFragment);
    const container = viewContainerRef.createComponent(factory);
    container.instance.modalTitle = title;
    container.instance.attacheToEdit = objectToEdit;
    const sub = container.instance.closeEmitter.subscribe(async object => {
      if (!object) {
        const confirmModal = this.openModalConfirmation(viewContainerRef, "Annulation", "Confirmez-vous l'annulation de la saisie ? Les données ne seront pas enregistrées.");
        confirmModal.instance.closeEmitter.subscribe(res => {
          if (res) {
            this.close(container);
          }
        });
      } else {
        const loadingModal = this.openLoading(viewContainerRef);
        await this.closeEmitter.emit({ object: object, loadingModal: loadingModal, aideSaisieFragment: container });
      }
    });
    return container;
  }

  public openModalRechercheBddMedic(viewContainerRef: ViewContainerRef, patientId: string, patientProfile: SynapsePatientProfile, listMedicsToAdd?: SynapseEntiteTherapeutique[], preview?: boolean): ComponentRef<RechercheBddMedFragment> {
    const factory = this.resolver.resolveComponentFactory(RechercheBddMedFragment);
    const container = viewContainerRef.createComponent(factory);
    container.instance.patientId = patientId;
    if (patientProfile.grounds.hepaticFailure) {
      patientProfile.grounds.hepaticFailure = container.instance.translateHepatSynapse(patientProfile.grounds.hepaticFailure);
    } else {
      patientProfile.grounds.hepaticFailure = SynapseHepaticFailureEnum.NONE;
    }
    if (patientProfile.grounds.cardiacFailure) {
      patientProfile.grounds.cardiacFailure = container.instance.translateCardiacSynapse(patientProfile.grounds.cardiacFailure);
    } else {
      patientProfile.grounds.cardiacFailure = SynapseCardiacFailureEnum.NONE;
    }
    if (patientProfile.grounds.cardiacFailure) {
      patientProfile.grounds.cardiacFailure = container.instance.translateCardiacSynapse(patientProfile.grounds.cardiacFailure);
    }
    if (listMedicsToAdd && listMedicsToAdd.length > 0) {
      container.instance.selectListOfMedic = listMedicsToAdd;
    }
    if (!patientProfile.creatinine || !patientProfile.creatinine.unit || !patientProfile.creatinine.value) {
      patientProfile.grounds.kidneyFailure = SynapseKidneyFailureEnum.NONE;
    }
    if (preview) {
      container.instance.preview = preview;
    }
    container.instance.profile = patientProfile;

    return container;
  }

  public openModalSaisieGuidee(viewContainerRef: ViewContainerRef, ligneSaisieGuidee: any): ComponentRef<SaisieGuideeFragment> {
    const factory = this.resolver.resolveComponentFactory(SaisieGuideeFragment);
    const container = viewContainerRef.createComponent(factory);
    container.instance.ligneSaisieGuidee = ligneSaisieGuidee;
    const sub = container.instance.closeEmitter.subscribe(async object => {
      if (!object) {
        this.close(container);
      } else {
        await this.closeEmitter.emit({ object: object, fragment: container });
      }
    });
    return container;
  }

  public openModalSearchCritere(viewContainerRef: ViewContainerRef): ComponentRef<SearchCritereFragment> {
    const factory = this.resolver.resolveComponentFactory(SearchCritereFragment);
    const container = viewContainerRef.createComponent(factory);
    const sub = container.instance.closeEmitter.subscribe(async object => {
      if (!object) {
        this.close(container);
      } else {
        await this.closeEmitter.emit({ object: object, fragment: container });
      }
    });
    return container;
  }

  public openModalSelectConsultation(viewContainerRef: ViewContainerRef, consults: Consultation[]): ComponentRef<SelectConsultationFragment> {
    const factory = this.resolver.resolveComponentFactory(SelectConsultationFragment);
    const container = viewContainerRef.createComponent(factory);
    container.instance.untouchedConsultations = consults;
    const sub = container.instance.closeEmitter.subscribe(async object => {
      if (!object) {
        this.close(container);
        sub.unsubscribe();
      } else {
        await this.closeEmitter.emit({ object: object, fragment: container });
        sub.unsubscribe();
      }
    });
    return container;
  }

  public openModalConsultData(viewContainerRef: ViewContainerRef, patientId: string, criteres: CritereHistoriqueItem[]): ComponentRef<ConsultDataFragment> {
    const factory = this.resolver.resolveComponentFactory(ConsultDataFragment);
    const container = viewContainerRef.createComponent(factory);

    container.instance.patientId = patientId;
    container.instance.criteres = [...criteres];

    const sub = container.instance.closeEmitter.subscribe(() => {
      this.close(container);
      sub.unsubscribe();
    });

    return container;
  }

  openModalEditCourrier(viewContainerRef: ViewContainerRef, patientId: string, consultId: string, courrierToEdit?: Courrier, newCourrier?: CreateCourrier): ComponentRef<EditCourrierFragment> {
    const factory = this.resolver.resolveComponentFactory(EditCourrierFragment);
    const container = viewContainerRef.createComponent(factory);
    if (courrierToEdit) {
      container.instance.courrierToEdit = courrierToEdit;
    }
    if (newCourrier) {
      container.instance.newCourrier = newCourrier;
    }
    container.instance.paitentId = patientId;
    container.instance.consultId = consultId;
    const sub = container.instance.closeEmitter.subscribe(() => {
      this.close(container);
      sub.unsubscribe();
    });
    return container;
  }

  openModalEditOrdonnance(viewContainerRef: ViewContainerRef, patientId: string, consultId: string, textToPrint: any): ComponentRef<EditOrdonnanceFragment> {
    const factory = this.resolver.resolveComponentFactory(EditOrdonnanceFragment);
    const container = viewContainerRef.createComponent(factory);

    container.instance.textToPrint = textToPrint;
    container.instance.patientId = patientId;
    container.instance.consultationId = consultId;
    const sub = container.instance.closeEmitter.subscribe(() => {
      this.close(container);
      sub.unsubscribe();
    });
    return container;
  }

  openModalAddCourrierPerso(viewContainerRef: ViewContainerRef): ComponentRef<AddCourrierPersoFragment> {
    const factory = this.resolver.resolveComponentFactory(AddCourrierPersoFragment);
    const container = viewContainerRef.createComponent(factory);
    const sub = container.instance.closeEmitter.subscribe(() => {
      this.close(container);
      sub.unsubscribe();
    });
    return container;
  }
/**
 * Modale pour ajouter des correspondants dans les mails
 * @param viewContainerRef
 * @param patientId
 * @param courrierId
 * @param isApicryptAccount
 * @returns
 */
  openModalCorrespondantCourrier(viewContainerRef: ViewContainerRef, patientId: string, courrierId: string , option: string, correspondantsArray: Correspondant[], isApicryptAccount?:boolean): ComponentRef<AddCorrespondantCourrier> {
    const factory = this.resolver.resolveComponentFactory(AddCorrespondantCourrier);
    const container = viewContainerRef.createComponent(factory);
    container.instance.idPatient = patientId;
    container.instance.idCourrier = courrierId;
    container.instance.isApicryptAccount = isApicryptAccount;
    container.instance.option = option;
    container.instance.correspondantsArray = correspondantsArray;
    const sub = container.instance.closeEmitter.subscribe((selectedCorrespondants) => {
      this.closeEmitter.emit(selectedCorrespondants);
      this.close(container);
      sub.unsubscribe();
    });
    return container;
  }

  /**
   * Modale d'ajout d'un pavé correspondant dans edit-courrier
   * @param viewContainerRef
   * @param correspondants
   * @returns
   */
  openModalCorrespondantInEditor(viewContainerRef: ViewContainerRef, correspondants:Correspondant[]): ComponentRef<AddCorrespondantInEditorComponent> {
    const factory = this.resolver.resolveComponentFactory(AddCorrespondantInEditorComponent);
    const container = viewContainerRef.createComponent(factory);
    container.instance.selectBodyTable.objects = correspondants;
    const sub = container.instance.closeEmitter.subscribe(() => {
      this.close(container);
      sub.unsubscribe();
    });
    return container;
  }


  public openModalAlarme(title: string, viewContainerRef: ViewContainerRef, patientId: string, fichePatient: FichePatient, titrePatient: string, alarmesPatient: Paginated<AlarmsPatient>, recherchesPatient: Paginated<RechercheMultiCriteres>): ComponentRef<AlarmeFragment> {
    const factory = this.resolver.resolveComponentFactory(AlarmeFragment);
    const container = viewContainerRef.createComponent(factory);
    container.instance.modalTitle = title;
    container.instance.modalFichePatient = fichePatient;
    container.instance.modalTitrePatient = titrePatient;
    container.instance.listAlarmesPatient = alarmesPatient;
    container.instance.recherchesPatient = recherchesPatient;
    container.instance.patientId = patientId;
    const sub = container.instance.closeEmitter.subscribe((object: any) => {
      if (!object) {
        this.close(container);
      } else {
        const loadingModal = this.openLoading(viewContainerRef);
        this.closeEmitter.emit({ loadingModal: loadingModal, alarmeFragment: container });
        this.close(container);
      }
      sub.unsubscribe();
    });
    return container;
  }

  openModalFamille(viewContainerRef: ViewContainerRef, idPatient: string): ComponentRef<ParentPatientFragment> {
    const factory = this.resolver.resolveComponentFactory(ParentPatientFragment);
    const container = viewContainerRef.createComponent(factory);
    container.instance.idPatient = idPatient;
    const sub = container.instance.closeEmitter.subscribe(resp => {
      this.close(container);
      sub.unsubscribe();
    });
    return container;
  }

  public openModalHistoProfession(viewContainerRef: ViewContainerRef, isEdit: boolean, listProfession: Paginated<Profession>, idPatient: string): ComponentRef<HistoProfessionFragment> {
    const factory = this.resolver.resolveComponentFactory(HistoProfessionFragment);
    const container = viewContainerRef.createComponent(factory);
    container.instance.isEdit = isEdit;
    container.instance.listProfession = listProfession;
    container.instance.idPatient = idPatient;
    const sub = container.instance.closeEmitter.subscribe(async object => {
      if (!object) {
        this.close(container);
      } else {
        const loadingModal = this.openLoading(viewContainerRef);
        await this.closeEmitter.emit({ definition: "profession", object: object, loadingModal: loadingModal, histoProfessionFragment: container });
      }
    });
    return container;
  }

  openModalHistoContact(viewContainerRef: ViewContainerRef, isEdit: boolean, listContact: Paginated<Adresse>, idPatient: string): ComponentRef<HistoContactFragment> {
    const factory = this.resolver.resolveComponentFactory(HistoContactFragment);
    const container = viewContainerRef.createComponent(factory);
    container.instance.isEdit = isEdit;
    container.instance.listContact = listContact;
    container.instance.idPatient = idPatient;
    const sub = container.instance.closeEmitter.subscribe(async object => {
      if (!object) {
        this.close(container);
      } else {
        const loadingModal = this.openLoading(viewContainerRef);
        await this.closeEmitter.emit({ definition: "contact", object: object, loadingModal: loadingModal, histoContactFragment: container });
      }
    });
    return container;
  }

  openModalHistoRepertoire(viewContainerRef: ViewContainerRef, isEdit: boolean, repertoire: ContactsPatient, idPatient: string): ComponentRef<HistoRepertoireFragment> {
    const factory = this.resolver.resolveComponentFactory(HistoRepertoireFragment);
    const container = viewContainerRef.createComponent(factory);
    container.instance.isEditCorrepondant = isEdit;
    container.instance.isEditIntervenant = isEdit;
    container.instance.isEditPersonne = isEdit;
    container.instance.repertoire = repertoire;
    container.instance.idPatient = idPatient;
    const sub = container.instance.closeEmitter.subscribe(async object => {
      if (!object) {
        this.close(container);
      } else {
        const loadingModal = this.openLoading(viewContainerRef);
        await this.closeEmitter.emit({ definition: "repertoire", object: object, loadingModal: loadingModal, histoRepertoireFragment: container });
      }
    });
    return container;
  }

  public openModalListeRecherchesMultiCriteres(viewContainerRef: ViewContainerRef, header: string, refreshStream: Subject<any>): ComponentRef<RechercheMultiListeFragment> {
    const factory = this.resolver.resolveComponentFactory(RechercheMultiListeFragment);
    const container = viewContainerRef.createComponent(factory);
    container.instance.header = header;
    container.instance.refreshStream = refreshStream;
    const sub = container.instance.closeEmitter.subscribe((object: any) => {
      if (!object) {
        this.close(container);
      } else {
        const loadingModal = this.openLoading(viewContainerRef);
        this.closeEmitter.emit({ object: object, loadingModal: loadingModal, memoFragment: container });
        this.close(container);
      }
      sub.unsubscribe();
    });
    return container;
  }

  public openModalSaveRecherchesMultiCriteres(viewContainerRef: ViewContainerRef, header: string, recherche: RechercheMultiCriteres, refreshStream: Subject<any>): ComponentRef<RechercheMultiSaveFragment> {
    const factory = this.resolver.resolveComponentFactory(RechercheMultiSaveFragment);
    const container = viewContainerRef.createComponent(factory);
    container.instance.header = header;
    container.instance.recherche = recherche;
    container.instance.refreshStream = refreshStream;
    const sub = container.instance.closeEmitter.subscribe((object: any) => {
      if (!object) {
        this.close(container);
      } else {
        const loadingModal = this.openLoading(viewContainerRef);
        this.closeEmitter.emit({ object: object, loadingModal: loadingModal, memoFragment: container });
        this.close(container);
      }
      sub.unsubscribe();
    });
    return container;
  }

  public openModalSaveReferentiel(viewContainerRef: ViewContainerRef, header: string, nomTable: string, referentiel: Referentiel, refreshStream: Subject<any>): ComponentRef<ReferentielNewFragment> {
    const factory = this.resolver.resolveComponentFactory(ReferentielNewFragment);
    const container = viewContainerRef.createComponent(factory);
    container.instance.header = header;
    container.instance.referentiel = referentiel;
    container.instance.nomTable = nomTable;
    container.instance.refreshStream = refreshStream;
    const sub = container.instance.closeEmitter.subscribe((object: any) => {
      if (!object) {
        this.close(container);
      } else {
        const loadingModal = this.openLoading(viewContainerRef);
        this.closeEmitter.emit({ object: object, loadingModal: loadingModal, memoFragment: container });
        this.close(container);
      }
      sub.unsubscribe();
    });
    return container;
  }

  public openModalSaveGroupementCriteres(viewContainerRef: ViewContainerRef, header: string, groupement: GroupementCriteres, refreshStream: Subject<any>): ComponentRef<GroupementNewFragment> {
    const factory = this.resolver.resolveComponentFactory(GroupementNewFragment);
    const container = viewContainerRef.createComponent(factory);
    container.instance.header = header;
    container.instance.groupement = groupement;
    container.instance.refreshStream = refreshStream;
    const sub = container.instance.closeEmitter.subscribe((object: any) => {
      if (!object) {
        this.close(container);
      } else {
        const loadingModal = this.openLoading(viewContainerRef);
        this.closeEmitter.emit({ object: object, loadingModal: loadingModal, memoFragment: container });
        this.close(container);
      }
      sub.unsubscribe();
    });
    return container;
  }

  public openModalSelectList(viewContainerRef: ViewContainerRef, header: string, columnTable: any, bodyTable: any, errorMessage: string, searchFilters?: Paginated<any>, searchObject?: any, searchFunction?: (object: any, filtres: Filtres) => Promise<Paginated<any>>) {
    const factory = this.resolver.resolveComponentFactory(SelectListFragment);
    const container = viewContainerRef.createComponent(factory);
    container.instance.header = header;
    container.instance.dataColumnTable = columnTable;
    container.instance.data = bodyTable;
    container.instance.errorMessage = errorMessage;
    container.instance.dataBodyTable = {
      page: searchFilters ? searchFilters.page ?? 1 : 1,
      perpage: searchFilters ? searchFilters.perpage ?? -1 : -1,
      total: searchFilters ? searchFilters.total ?? 0 : 0,
      objects: []
    };
    container.instance.searchObject = searchObject;
    container.instance.searchFunction = searchFunction;
    return container;
  }

  public openModalRechercheProduitNom(viewContainerRef: ViewContainerRef) {
    const factory = this.resolver.resolveComponentFactory(SearchMedNomFragment);
    const container = viewContainerRef.createComponent(factory);
    return container;
  }

  public openModalInsi(title: string, viewContainerRef: ViewContainerRef) {
    const factory = this.resolver.resolveComponentFactory(InsiFragment);
    const container = viewContainerRef.createComponent(factory);
    container.instance.modalTitle = title;

    return container;
  }

  public openModalSearchPatient(viewContainerRef: ViewContainerRef) {
    const factory = this.resolver.resolveComponentFactory(SearchPatientsFragment);
    const container = viewContainerRef.createComponent(factory);
    return container;
  }

  public openModalSearchCIM10(viewContainerRef: ViewContainerRef) {
    const factory = this.resolver.resolveComponentFactory(SearchCim10Fragment);
    const container = viewContainerRef.createComponent(factory);
    return container;
  }

    public openModalAdressePatient(viewContainerRef: ViewContainerRef){
    const factory = this.resolver.resolveComponentFactory(EditAdressePatientComponent);
    const container = viewContainerRef.createComponent(factory);
    const sub = container.instance.closeEmitter.subscribe(() => {
      this.close(container);
      sub.unsubscribe();
    });
    return container;
  }

  /**
   * Ouvre une modale pour sélectionner un document (patient ou utilisateur) à insérer dans le courrier
   * @param viewContainerRef
   * @param patientId
   * @param consultId
   * @returns
   */
  public openModalSelectDocument(
    viewContainerRef: ViewContainerRef,
    patientId: string,
    consultId: string
  ): ComponentRef<SelectDocumentModalComponent> {
    const factory = this.resolver.resolveComponentFactory(SelectDocumentModalComponent);
    const container = viewContainerRef.createComponent(factory);
    container.instance.patientId = patientId;
    container.instance.consultId = consultId;
    return container;
  }

  public close(componentRef: ComponentRef<unknown>): void {
    if (componentRef) {
      componentRef.destroy();
    }
  }

  public openConfirmCustom(viewContainerRef: ViewContainerRef, header: string, msg: string, actions: string[], opts?: { msgIsHtml?: boolean; dismissible?: boolean; autoFocus?: 'none'|'first'|'cancel'|number|string  }): Promise<string | null> {
    const factory = this.resolver.resolveComponentFactory(ConfirmationChoixCustomComponent);
    const ref = viewContainerRef.createComponent(factory);

    ref.instance.header = header;
    ref.instance.msg = msg;
    ref.instance.list = actions || [];
    ref.instance.msgIsHtml = !!opts?.msgIsHtml;
    ref.instance.dismissible = opts?.dismissible !== false;
    ref.instance.autoFocus = opts?.autoFocus;


    return new Promise((resolve) => {
      const s1 = ref.instance.select.subscribe((label) => { cleanup(); resolve(label); });
      const s2 = ref.instance.closed.subscribe(() => { cleanup(); resolve(null); });
      const cleanup = () => { s1.unsubscribe(); s2.unsubscribe(); this.close(ref); };
    });
  }
}
